import * as Sentry from '@sentry/browser';
import { SESSION_PRODUCT_NAME } from './utils/storage';
import { APP_VERSION } from './utils/version';

const initSentry = () => {
  if (SENTRY_ENV === 'local') return;

  Sentry.init({
    dsn: SENTRY_URL,
    environment: SENTRY_ENV,
    release: APP_VERSION,
    ignoreErrors: [
      '#tmn-full-content',
      '#tmn-status-bar-white',
      'Non-Error promise rejection captured with value',
    ],
    beforeSend(event) {
      const originExtra = event.extra;
      event.extra = {
        ...originExtra,
        productName: sessionStorage.getItem(SESSION_PRODUCT_NAME) ?? 'unknown',
      };
      return event;
    },
  });
};

initSentry();
